import Vue from "vue";
import {mapGetters, mapActions} from 'vuex';
import moment from 'moment';

const mixin = {

	data: () => ({
		buttonSizeDefault: 48,

		// Lookup Values for selection fields
		appSupportTypesOptionsData: [
			'General Enquiry',
			'Problem',
			'Request',
			'Suggestion',
		],
		answersOptionsData: [
			'Yes',
			'No',
		],
		correctAnswersOptionsData: [
			'Yes',
			'No',
		],
		extendedScheduleOptionsData: [
			'Day Off',
			'Holiday',
			'Working from Home',
			'Working Off Site'
		],
		questionTypesOptionsData: [
			'Covid'
		],
		responseTimesOptionsData: [
			'Immediate',
			'24 Hours',
			'3 Days'
		],
		observationPriorityOptionsData: [
			'Very High',
			'High',
			'Medium',
			'Low'
		],
		observationTypesOptionsData: [
			'Accident',
			'Cleaning',
			// 'Environmental',
			'Incident',
			'IT Support',
			'Maintenance',
			'Near Miss',
			// 'Quality',
			// 'Safety',
		],
		observationStatusOptionsData: [
			'Pending',
			'In Progress',
			'Resolved'
		],
		userCategoriesOptionsData: [
			'Office Staff',
			'Site Staff',
			'Visitors'
		],
		userRolesOptionsData: [
			'Admin',
			'Manager',
			'User',
		],
		userStatusOptionsData: [
			'PENDING',
			'APPROVED',
			'SUSPENDED',
			'ARCHIVED',
		],
		userTypesOptionsData: [
			'Staff',
			'Player',
			'Visitor',
			'Contractor',
			'Developer'
		],
		userTypesOptionsDataExtended: [
			'Staff',
			'Warriors',
			'Warriors Women',
			'Visitor',
			'Contractor',
			'Developer'
		],
		userAccessAbilitiesOptionsData: [
			'Covid',
			'Edit Covid Answers (Requires Covid)',
			'Create Contractors',
			'Fire Marshall',
			'First Aider',
			'Sign in from Desktop',
		],
		sitePermitStatusOptionsData: [
			'Pending',
			'Approved',
			'Rejected',
			'Suspended',
		]

	}),

	methods: {
		...mapActions([
			'ACT_mobileNav',
			'ACT_breadcrumbs',
			'ACT_panelLayout',
			'ACT_openStaffDirectory',
			'ACT_openConcern',
			'ACT_openTrainingCourse',
			'ACT_openClients',
			'ACT_openSites',
			'ACT_openQuestion',
			'ACT_trainingCourses',
			'ACT_lookupValues',
			'ACT_sites',
		]),

		// * Set mobile menu
		MIX_mobileNav(payload) {
			this.ACT_mobileNav(payload);
		},

		// * PANEL LAYOUT
		MIX_setPanelLayout(leftPanel, rightPanel, show, title, dynamicComponent) {
			this.ACT_panelLayout({
				leftPanel: leftPanel,
				rightPanel: rightPanel,
				show: show,
				title: title,
				dynamicComponent: dynamicComponent
			});
		},

		MIX_breakpoint() {
			return (this.$vuetify.breakpoint.name);
		},

		MIX_itemsPerPage: function (breakpoint) {
			var result = 5;
			switch (breakpoint) {
				case 'xs':
					result = 1;
					break;
				case 'sm':
					result = 5;
					break;
				case 'md':
					result = 10;
					break;
				case 'lg':
					result = 10;
					break;
				case 'xl':
					result = 10;
					break;
				default:
					result = 5;
					break;
			}
			return result;
		},

		// * VIEW RELATED MIXINS
		MIX_closeView() {
			this.MIX_puDialog(false, '', '', '');
			this.MIX_fsDialog(false, ''); // Close Full Screen Dialog
			// this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
		},

		// * Capitalize JS String
		MIX_capitalizeText(text) {
			var capitalized = text.toLowerCase();
			capitalized = capitalized.charAt(0).toUpperCase() + capitalized.slice(1);
			return capitalized;
		},

		// * MIX BACK
		MIX_back() {
			this.$router.go(-1);
		},

		// * CHANGE ROUTE FUNCTION
		MIX_go(path) {
			this.$router.push(path).catch((err) => {
				console.log("Route error: " + err);
			});
		},

		// * FORMAT DATE TIME
		MIX_formatDateTime: function (date, formatIn, formatOut) {
			if ((date !== '') && (date !== null) && (date !== undefined)) {
				return moment(date, formatIn).format(formatOut);
			} else {
				return ''
			}
		},


		MIX_exportDocuments(headers, fileTitle, formatExport) {
			const items = formatExport

			if (headers && items[0] !== headers) {
				items.unshift(headers)
			}

			const jsonObject = JSON.stringify(items)

			// convert object to csv
			const array = typeof jsonObject != "object" ? JSON.parse(jsonObject) : jsonObject

			let str = ""

			for (let i = 0; i < array.length; i++) {
				let line = ""

				for (let index in array[i]) {
					if (line !== "") line += ","
					line += array[i][index];
				}

				str += line + "\r\n"
			}

			const csv = str
			const exportedFilename = fileTitle + ".csv" || "export.csv"
			const blob = new Blob([csv], {type: "text/csv;charset=utf-8;"})

			if (navigator.msSaveBlob) {
				navigator.msSaveBlob(blob, exportedFilename);
			} else {
				const link = document.createElement("a")

				if (link.download !== undefined) {
					const url = URL.createObjectURL(blob)
					link.setAttribute("href", url)
					link.setAttribute("download", exportedFilename)
					link.style.visibility = "hidden"
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)
				}
			}
		},

		// * sort by createdDateTime
		MIX_sortByCreatedDateTime(toSortObject) {
			var t = this;
			return toSortObject.sort(function (left, right) {
				return t.$moment(right.createdDateTime, "x").diff(t.$moment(left.createdDateTime, "x"))
			});
		},

		// MIXIN TO LOAD DATABASE DATA INTO LOOKUP TABLES STORE
		MIX_lookupTables: function () {
			var t = this;
			return new Promise(async function (resolve) {
				var lookupTablesResult = await t.MIX_readDocuments('lookupTables');
				if (lookupTablesResult.code === 1) {
					t.ACT_lookupTables(lookupTablesResult.data);
				} else {
					console.log('ERROR with lookupTablesResult \n' + JSON.stringify(lookupTablesResult, null, 2))
				}
				resolve();
			})
		},
		// MIXIN TO LOAD DATABASE DATA INTO LOOKUP VALUES STORE
		MIX_lookupValues: function () {
			var t = this;
			return new Promise(async function (resolve) {
				// GET LOOKUP VALUES
				var lookupValuesResult = await t.MIX_readDocuments('lookupValues');
				if (lookupValuesResult.code === 1) {
					t.ACT_lookupValues(lookupValuesResult.data);
				} else {
					console.log('ERROR with lookupValuesResult \n' + JSON.stringify(lookupValuesResult, null, 2))
				}
				resolve();
			})
		},

		// * Page Details
		MIX_breadcrumbs(breadcrumbs) {
			this.ACT_breadcrumbs(breadcrumbs);
		},

		// TO DELETE COMMENTS/LOCATIONS/CONCERNS FROM SUBARRAYS
		MIX_deleteCollectionArray(id, item, collection, parentCollection, parentId) {
			var name = '';
			switch (collection) {
				case 'comments':
					name = item.comment;
					break;
				case 'locations':
					name = item.locationName;
					break;
			}
			var title = 'Delete ' + name;
			var message = 'Are you sure you want to delete the item ' + name + '?';
			var actionDetails = {
				actionName: 'delete',
				collection: collection, // to add delete flag to doc from collection
				itemId: id,
				parentCollection: parentCollection, // to remove from the item id from the collection
				parentId: parentId,
			}

			this.MIX_showConfirmation(true, title, message, 290, "YES", "NO", actionDetails);
		},

		// SITES
		MIX_sites: function () {
			var t = this;
			return new Promise(async function (resolve) {
				var sitesResult = await t.MIX_readDocuments('sites');
				if (sitesResult.code === 1) {
					let sites = sitesResult.data.map((site) => {
						return {
							'siteId': site.id,
							'siteName': site.siteName,
							'siteType': site.siteType,
							'sitePostcode': site.sitePostcode
						}
					});
					t.ACT_sites(sites);
				} else {
					t.MIX_alert(sitesResult.code, sitesResult.message, sitesResult.data, sitesResult.error);
				}
				resolve();
			})
		},

		MIX_generateId() {
			// Alphanumeric characters
			const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			let generatedId = ''
			for (let i = 0; i < 20; i++) {
				generatedId += chars.charAt(Math.floor(Math.random() * chars.length))
			}

			return generatedId
		},

		/**
		 * From Now
		 *
		 * Takes a date, format and ago parameters and returns a string containing the amount of time since creating the concern.
		 *
		 * @param date - the creation date
		 * @param formatIn - the format of the creation date
		 * @param ago - boolean to toggle the 'ago' keyword from the returned string
		 * @returns {string} - the time since concern creation e.g. '1 hour'
		 */
		MIX_fromNow: function (date, formatIn, ago) {
			return moment(date, formatIn).fromNow(ago);
		},

	}
}

export default {
	install(Vue, options) {
		Vue.mixin(mixin)
	}
}
